// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import pageReducer from "../features/pageSlice";
import boxesReducer from "../features/boxesSlice";
import boxDeatilsReducer from "../features/boxDetailsSlice";
import allBoxesReducer from "../features/allBoxesSlice";
import userReducer from "../features/userSlice";
import chaosBoxesReducer from "../features/chaosSlice";
import settingsSlice from "../features/settingsSlice";
import bannersSlice from "../features/bannersSlice";
import vipSlice from "../features/vipSlice";
import liveFeedReducer from '../features/liveFeedSlice';
import receivedGiftBoxesReducer from "../features/receivedBoxesSlice";
import sentBoxesSliceReducer from "../features/sentBoxesSlice";
import walletSliceReducer from "../features/walletSlice";
import winningSliceReducer from "../features/winningSlice";
import { keycloakUsersReducer, keycloakWalletReducer, keycloakCryptoReducer, keycloakAuthReducer, keycloakMerkleWalletModalReducer, keycloakACLReducer, keycloakMerkleTreeReducer } from 'keycloakauthmodule'; // ✅ import from installed module
import rewardSlice from "../features/rewardSlice";
import contactSlice from "../features/contactSlice";
import giftCategoriesSlice from "../features/giftCategoriesSlice";



export const store = configureStore({
  reducer: {
    page: pageReducer,
    boxes: boxesReducer,
    boxDetails: boxDeatilsReducer,
    allBoxes: allBoxesReducer,
    user: userReducer,
    chaosBoxes: chaosBoxesReducer,
    banners: bannersSlice,
    settings: settingsSlice,
    vip:vipSlice,
    liveFeed: liveFeedReducer,
    receivedGiftBoxes: receivedGiftBoxesReducer,
    sentGiftBoxesSlice:sentBoxesSliceReducer,
    wallet:walletSliceReducer,
    winningSice:winningSliceReducer,
    authSlice: keycloakAuthReducer,
    wallets: keycloakWalletReducer,
    users: keycloakUsersReducer,
    crypto: keycloakCryptoReducer,
    walletModal: keycloakMerkleWalletModalReducer,
    acl: keycloakACLReducer,
    merkleTree: keycloakMerkleTreeReducer,
    rewards:rewardSlice,
    contact:contactSlice,
    giftCategories:giftCategoriesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

